import { aboutContent } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full max-w-[520px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-secondary-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20space%20filled%20with%20colorful%20manga%20books%20on%20wooden%20shelves%2C%20soft%20afternoon%20sunlight%20streaming%20through%20window%2C%20comfortable%20armchair%20with%20cushion%2C%20peaceful%20atmosphere%2C%20warm%20cream%20and%20wood%20tones%2C%20lifestyle%20editorial%20photography%20with%20gentle%20shadows&width=1040&height=780&seq=about-manga-bg&orientation=landscape"
                alt="樱花漫画网 - 关于我们"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-information-line"></i>
              <span>品牌故事</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-6">{aboutContent.title}</h2>
            <div className="space-y-4">
              {aboutContent.paragraphs.map((p, i) => (
                <p key={i} className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {p}
                </p>
              ))}
            </div>
            <div className="flex flex-wrap gap-4 mt-7">
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                </div>
                <span>30,000+ 漫画资源</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                </div>
                <span>每日 200+ 更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                </div>
                <span>500 万+ 活跃漫迷</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}